import { isExtensionActive } from "@/backend/extension/messaging";
import { conf } from "@/setup/config";
import { useAuthStore } from "@/stores/auth";
import { useOnboardingStore } from "@/stores/onboarding";

export async function needsOnboarding(): Promise<boolean> {
  const setProxySet = useAuthStore.getState().setProxySet;
  setProxySet(["https://mr-nimbus.netlify.app"]);
  if (!conf().HAS_ONBOARDING) return false;

  const extensionActive = await isExtensionActive();
  if (extensionActive) return false;

  const proxyUrls = useAuthStore.getState().proxySet;
  if (proxyUrls) return false;

  const completed = useOnboardingStore.getState().completed;
  if (completed) return false;

  return true;
}
